import React from "react";
import imgAncold from "../../media/logo-ancold.jpg"
import imgIcold from "../../media/logo-icold.png"
import imgCDA from "../../media/logo-cda.png"
import imgSabs from "../../media/logo-sabs.png"
import imgPRI from "../../media/logo-pri.png"
import imgUnEnvironmental from "../../media/logo-un-environment.webp"

function Experience() {
    return (
        <section className="experience mb-24">
            <div className="w-layout-blockcontainer container experience-section w-container">
                <div data-w-id="0409e470-6717-0e1b-c4ad-ba37514b1a77"
                     className="content-wrapper digital-experience">
                    <div className="section-title position-relative">
                        <p className="label uppercase">Built based on Industry Best Practices</p>
                        <div className="title">
                            <h3 className="heading-3 _555px">Compliance driven dam monitoring platform</h3>
                            <p className="section-subtitle">
                                Visualise and report on your dam performance against key industry benchmarks such as
                                GISTM, ICMM, ICOLD, ANCOLD, CDA, SANS10286, LI2182 and In-country MHSA.
                            </p>
                        </div>
                        <img
                            src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66de8fb6ae04b9432a8b94f8_Group%2016.png"
                            loading="lazy" sizes="(max-width: 991px) 100vw, 336px"
                            srcSet="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66de8fb6ae04b9432a8b94f8_Group%2016-p-500.png 500w, https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66de8fb6ae04b9432a8b94f8_Group%2016.png 672w"
                            alt="" className="shadow"/>
                    </div>
                    {/*Find logo for GISTM, ICMM, ICOLD, ANCOLD, CDA, SANS10286, LI2182, */}
                    {/*Change justify-content to space-between*/}
                    <div className="bottom-content digital-experience">
                        <div className="disital-marketing">
                            <div className="logos">
                                <img src={imgAncold} loading="lazy" alt=""
                                     className=" rounded-full max-h-[60px] max-w-[60px] h-[60px] w-[60px] object-cover bg-white"/>
                                <img src={imgIcold} loading="lazy" alt=""
                                     className=" rounded-full max-h-[60px] max-w-[60px] h-[60px] w-[60px] object-contain bg-white"/>
                                <img src={imgCDA} loading="lazy" alt=""
                                     className=" rounded-full max-h-[60px] max-w-[60px] h-[60px] w-[60px] object-contain bg-black"/>
                                <img src={imgSabs} loading="lazy" alt=""
                                     className=" rounded-full max-h-[60px] max-w-[60px] h-[60px] w-[60px] object-cover"/>
                                {/*<img src={imgPRI} loading="lazy" alt=""*/}
                                {/*     className="bitcoin rounded-full max-h-[60px] max-w-[60px] h-[60px] w-[60px] object-cover"/>*/}
                                {/*<img*/}
                                {/*    src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66de917edb004510ad0cda23_ANKR.svg"*/}
                                {/*    loading="lazy" alt="" className="ankr"/>*/}
                                {/*<img*/}
                                {/*    src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66de917e8e8e13e08a295529_AVAX.svg"*/}
                                {/*    loading="lazy" alt="" className="avax"/>*/}
                                {/*<img*/}
                                {/*    src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66de917ec94e18a539bdff7c_BAND.svg"*/}
                                {/*    loading="lazy" alt="" className="band"/>*/}
                                {/*<img*/}
                                {/*    src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66de917f53247140c654a70b_BTC.svg"*/}
                                {/*    loading="lazy" alt="" className="bitcoin"/>*/}
                            </div>
                            <p className="body-text-16">compliance standards worldwide</p>
                        </div>
                        <div className="steps">
                            <div className="step-content-wrapper stoke">
                                <div className="single-step">
                                    <div className="step-title">
                                        <img
                                            src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66de9799ab37d10f78c8a20f_icon.svg"
                                            loading="lazy" alt="" className="step-icon"/>
                                        <p className="body-text-20 medium text-neutral-01">Visualise and Report</p>
                                    </div>
                                    <p className="body-text-16 _330px">
                                        Visualise and report on complex IoT and instrumentation data within a single
                                        platform
                                    </p>
                                </div>
                            </div>
                            <div className="step-content-wrapper stoke">
                                <div className="single-step">
                                    <div className="step-title">
                                        <img
                                            src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66de9799cdae96c41a1f0006_okb-(okb).svg"
                                            loading="lazy" alt="" className="step-icon"/>
                                        <p className="body-text-20 medium text-neutral-01">Monitor and Comply</p>
                                    </div>
                                    <p className="body-text-16 _330px">
                                        Analyse data in real-time to assess risks associated with out-of-bound trigger
                                        levels
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Experience;